import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";



import { Button, DatePicker, Input, Table, Typography, message } from "antd";



import { CopyOutlined, FileExcelOutlined, FilePdfOutlined, ReloadOutlined, SearchOutlined } from "@ant-design/icons";



import dayjs from "dayjs";



import "../css/sm-art-common.css";



import { BASE_URL, getUnitApiBaseFour, SUB_URL } from "../services/BaseUrl";



const { Title, Text } = Typography;



const readLoginField = (obj, keys) => {



  const sources = [obj?.data, obj?.user, obj];



  for (const source of sources) {



    if (!source || typeof source !== "object") continue;



    for (const key of keys) {



      const value = source[key];



      if (value !== undefined && value !== null && String(value).trim() !== "") {



        return String(value).trim();



      }



    }



  }



  return "";



};



const storedLoginField = (keys) => {



  for (const name of ["userData", "userdata", "user"]) {



    try {



      const raw = localStorage.getItem(name);



      if (!raw) continue;



      const value = readLoginField(JSON.parse(raw), keys);



      if (value) return value;



    } catch {



      // Continue when a stored value is not JSON.



    }



  }



  return "";



};



const getDepartmentId = (userdata) =>



  readLoginField(userdata, ["dept", "dept_id", "department_id"]) ||



  storedLoginField(["dept", "dept_id", "department_id"]) ||



  localStorage.getItem("dept") ||



  localStorage.getItem("dept_id") ||



  localStorage.getItem("department_id") ||



  "";



const getUnitCode = (userdata) =>



  readLoginField(userdata, ["unit_code"]) ||



  storedLoginField(["unit_code"]) ||



  localStorage.getItem("unit_code") ||



  "";



const getBacklogUrl = (deptId, unitCode, reportDate, refresh = false) => {



  let url;



  if (String(deptId) === "43") {



    // Department 43 uses the department-wide API. Do not pass a unit code.



    url = new URL("/index.php/backlog/unit_summary", BASE_URL.BASE);



  } else {



    if (!unitCode) throw new Error("unit_code missing. Please log in again.");



    const unitApiBase = getUnitApiBaseFour(unitCode);



    if (!unitApiBase) throw new Error("Unit API base URL is missing");



    const parsed = new URL(unitApiBase);



    const indexPath = parsed.pathname.match(/^(.*?\/index\.php)(?:\/|$)/i);



    if (!indexPath) throw new Error("Unit API base must include /index.php/.");



    const method = String(SUB_URL?.backlog_unit_summary || "unit_summary").replace(/^\/+/, "");



    url = new URL(parsed.origin);



    url.pathname = `${indexPath[1]}/Backlog/${encodeURIComponent(unitCode)}/${method}`;



  }



  url.searchParams.set("date", reportDate);



  if (refresh) url.searchParams.set("refresh", "1");



  return url.toString();



};



const NUMERIC_FIELDS = ["sewing_qty", "sewing_kanbans", "audited_qty", "audited_cartons", "backlog", "capacity_qty", "backlog_with_pm", "backlog_without_pm", "backlog_late_material", "total_finishing_backlog"];



// Main (single-row header) columns. Sewing Kanbans and Audited Cartons are hidden.
const MAIN_FIELDS = [
  ["Kanban Audited Qty", "sewing_qty"],
  ["Carton Audited Qty", "audited_qty"],
 // ["Backlog Qty", "backlog"],
  //["Capacity In Pcs", "capacity_qty"],
];

// Columns grouped under one "Finishing Backlog" header.
const FINISHING_GROUP_TITLE = "Finishing Backlog";
const FINISHING_FIELDS = [
  ["With Trims", "backlog_with_pm"],
  ["Without Trims", "backlog_without_pm"],
  ["Late Receipt of Trims", "backlog_late_material"],
  ["Total", "total_finishing_backlog"],
];

const EXPORT_FIELDS = [["Unit No.", "name"], ...MAIN_FIELDS, ...FINISHING_FIELDS];

// Two header rows for Copy / Excel / PDF, matching the on-screen grouped header.
const HEADER_ROW_1 = [
  "Unit No.",
  ...MAIN_FIELDS.map(([label]) => label),
  FINISHING_GROUP_TITLE,
  ...FINISHING_FIELDS.slice(1).map(() => ""),
];
const HEADER_ROW_2 = [
  "",
  ...MAIN_FIELDS.map(() => ""),
  ...FINISHING_FIELDS.map(([label]) => label),
];
const SINGLE_HEADER_COLS = 1 + MAIN_FIELDS.length;


const formatUnitLabel = (value) => {
  if (value == null || String(value).trim() === "") return "—";

  const text = String(value).trim().toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
};

const fmt = (value) => value === null || value === undefined || value === "" ? "—" : Number(value).toLocaleString("en-IN");



const toNumber = (value) => value === null || value === undefined || value === "" ? null : (Number.isFinite(Number(value)) ? Number(value) : null);



const normalizeRow = (entry, fallbackCode = "") => {



  const code = String(entry?.unit_code ?? fallbackCode ?? "");



  return {



    ...entry,



    code,



    name: formatUnitLabel(entry?.unit_name || (code ? `Unit ${code}` : "Unit")),



    ...Object.fromEntries(NUMERIC_FIELDS.map((field) => [field, toNumber(entry?.[field])])),



  };



};



const sumRows = (rows) => Object.fromEntries(NUMERIC_FIELDS.map((field) => [



  field,



  rows.reduce((sum, entry) => sum + (entry[field] ?? 0), 0),



]));



export default function FinishingBacklogReport({ userdata }) {



  const [date, setDate] = useState(() => dayjs().format("YYYY-MM-DD"));



  const [dataRows, setDataRows] = useState([]);



  const [metadata, setMetadata] = useState(null);



  const [apiTotals, setApiTotals] = useState(null);



  const [running, setRunning] = useState(false);



  const [error, setError] = useState("");



  const [search, setSearch] = useState("");



  const [page, setPage] = useState(1);



  const requestId = useRef(0);



  const abortRef = useRef(null);



  const deptId = getDepartmentId(userdata);



  const isDepartment43 = deptId === "43";



  const unitCode = isDepartment43 ? "" : getUnitCode(userdata);



  const load = useCallback(async (reportDate, refresh = false) => {



    const id = ++requestId.current;



    abortRef.current?.abort();



    const controller = new AbortController();



    abortRef.current = controller;



    setRunning(true);



    setError("");



    // Keep the last report visible while refreshing.



    try {



      const url = getBacklogUrl(deptId, unitCode, reportDate, refresh);



      const response = await fetch(url, { method: "GET", signal: controller.signal });



      if (!response.ok) throw new Error(`Backlog API returned HTTP ${response.status}`);



      const result = await response.json();



      if (result?.status !== true || !result.data) {



        throw new Error(result?.message || "Invalid backlog API response");



      }



      if (controller.signal.aborted || id !== requestId.current) return;



      const data = result.data;



      setMetadata(data);



      if (isDepartment43) {



        if (!Array.isArray(data.units)) throw new Error("Department 43 response is missing data.units");



        setDataRows(data.units.map((item) => normalizeRow(item)));



        setApiTotals(data.total && typeof data.total === "object" ? data.total : null);



      } else {



        const entry = Array.isArray(data.units)



          ? data.units.find((item) => String(item.unit_code) === String(unitCode))



          : data;



        if (!entry) throw new Error("The API did not return the logged-in unit");



        const responseCode = String(entry.unit_code ?? unitCode);



        if (responseCode !== String(unitCode)) throw new Error("The API returned data for a different unit");



        setDataRows([normalizeRow(entry, unitCode)]);



      }



    } catch (err) {



      if (controller.signal.aborted || id !== requestId.current) return;



      setError(err?.message || "Failed to load backlog report");



    } finally {



      if (id === requestId.current) setRunning(false);



    }



  }, [deptId, unitCode, isDepartment43]);



  useEffect(() => {

    load(date, false);

    return () => {

      ++requestId.current;

      abortRef.current?.abort();

    };

  }, [date, load]);



  const rows = useMemo(() => {



    const query = search.trim().toLowerCase();



    return query ? dataRows.filter((item) => `${item.name} ${item.code}`.toLowerCase().includes(query)) : dataRows;



  }, [dataRows, search]);



  const totals = useMemo(() => {



    const values = sumRows(dataRows);



    if (apiTotals) {



      for (const field of NUMERIC_FIELDS) {



        if (apiTotals[field] !== undefined && apiTotals[field] !== null) {



          values[field] = Number(apiTotals[field]);



        }



      }



    }



    return values;



  }, [dataRows, apiTotals]);



  const visibleTotals = useMemo(() => sumRows(rows), [rows]);



  const displayedTotal = search.trim() ? visibleTotals : totals;



  const exportData = () => [

    HEADER_ROW_1,

    HEADER_ROW_2,



    ...rows.map((item) => EXPORT_FIELDS.map(([, field]) => item[field] ?? "")),



    ["Total", ...EXPORT_FIELDS.slice(1).map(([, field]) => displayedTotal[field] ?? 0)],



  ];



  const onCopy = async () => {



    if (!rows.length) return message.warning("No data to copy");



    try {



      await navigator.clipboard.writeText(exportData().map((r) => r.join("\t")).join("\n"));



      message.success("Report copied");



    } catch {



      message.error("Unable to copy report");



    }



  };



  const onExcel = async () => {



    if (!rows.length) return message.warning("No data to export");



    try {



      const XLSX = await import("xlsx");



      const sheet = XLSX.utils.aoa_to_sheet([



        ["Finishing Backlog Report"],



        [`Report Date: ${date}`],



        [],



        ...exportData(),



      ]);



      sheet["!cols"] = EXPORT_FIELDS.map(([label]) => ({ wch: Math.max(15, label.length + 3) }));

      const headerTop = 3; // rows: title, date, blank, then the two header rows
      sheet["!merges"] = [
        ...Array.from({ length: SINGLE_HEADER_COLS }, (_v, c) => ({ s: { r: headerTop, c }, e: { r: headerTop + 1, c } })),
        { s: { r: headerTop, c: SINGLE_HEADER_COLS }, e: { r: headerTop, c: SINGLE_HEADER_COLS + FINISHING_FIELDS.length - 1 } },
      ];



      const book = XLSX.utils.book_new();



      XLSX.utils.book_append_sheet(book, sheet, "Backlog");



      XLSX.writeFile(book, `Finishing_Backlog_${isDepartment43 ? "Dept43" : unitCode}_${date}.xlsx`);



    } catch {



      message.error("Excel export failed");



    }



  };



  const onPDF = async () => {



    if (!rows.length) return message.warning("No data to export");



    try {



      const { jsPDF } = await import("jspdf");



      const module = await import("jspdf-autotable");



      const autoTable = module.default || module.autoTable;



      const pdf = new jsPDF("landscape");



      pdf.setFontSize(16);



      pdf.text("Finishing Backlog Report", 14, 17);



      pdf.setFontSize(10);



      pdf.text(`Report Date: ${date}`, 14, 25);



      const table = exportData();



      autoTable(pdf, {



        startY: 31,



        head: [
          [
            ...HEADER_ROW_1.slice(0, SINGLE_HEADER_COLS).map((label) => ({ content: label, rowSpan: 2, styles: { valign: "middle" } })),
            { content: FINISHING_GROUP_TITLE, colSpan: FINISHING_FIELDS.length, styles: { halign: "center" } },
          ],
          FINISHING_FIELDS.map(([label]) => label),
        ],



        body: table.slice(2).map((item) => item.map(String)),



        theme: "grid",



        styles: { fontSize: 8 },



      });



      pdf.save(`Finishing_Backlog_${isDepartment43 ? "Dept43" : unitCode}_${date}.pdf`);



    } catch {



      message.error("PDF export failed");



    }



  };



  const numberColumn = ([title, key], isFinishing) => ({
    title, key, dataIndex: key,
    width: isFinishing ? 150 : 118,
    align: "center",
    className: isFinishing ? "fbr-split-col" : "",
    render: (value) => <Text strong={key === "backlog" || key === "total_finishing_backlog"}>{fmt(value)}</Text>,
  });

  const columns = [



    { title: "Sl.No.", key: "sno", width: 126, align: "center", render: (_v, _r, index) => (page - 1) * 10 + index + 1 },



    { title: "Unit No.", dataIndex: "name", key: "name", width: 124, render: (value) => <Text strong>{formatUnitLabel(value)}</Text> },

    ...MAIN_FIELDS.map((field) => numberColumn(field, false)),

    {
      title: FINISHING_GROUP_TITLE,
      key: "finishing_backlog_group",
      align: "center",
      className: "fbr-split-col fbr-group-col",
      children: FINISHING_FIELDS.map((field) => numberColumn(field, true)),
    },

  ];



  const count = rows.length;



  const available = (value) => value !== undefined && value !== null;



  const splitCount = isDepartment43



    ? dataRows.reduce((sum, item) => sum + (Number(item.split_entered_count) || 0), 0)



    : metadata?.split_entered_count;



  const mismatchCount = isDepartment43



    ? dataRows.reduce((sum, item) => sum + (Number(item.split_mismatch_count) || 0), 0)



    : metadata?.split_mismatch_count;



  const styleCount = isDepartment43



    ? dataRows.reduce((sum, item) => sum + (Number(item.style_count) || 0), 0)



    : metadata?.style_count;



  return (



    <div className="sm-page finishing-backlog-page fbr-refined">



      <div className="sm-page-inner">



        <div className="fbr-panel">



                      <div className="fbr-heading">

              <div className="fbr-heading-copy">

                <Title level={3} className="sm-page-title">Finishing Backlog Report</Title>

                <Text className="fbr-subtitle">{isDepartment43 ? "All units" : (dataRows[0]?.name || `Unit ${unitCode || "—"}`)} · {dayjs(date).format("DD/MM/YYYY")}</Text>

              </div>

              <Text className="fbr-record-label">Total Records <strong>{dataRows.length}</strong></Text>

            </div>



<div className="fbr-toolbar">



            <Input className="fbr-search" allowClear prefix={<SearchOutlined />} placeholder="Search unit name or code"



              value={search} onChange={(e) => { setPage(1); setSearch(e.target.value); }} />



            <DatePicker className="fbr-date" allowClear={false} format="DD/MM/YYYY" value={dayjs(date)}



              disabledDate={(d) => d && d.isAfter(dayjs(), "day")}



              onChange={(v) => { if (v) { setDate(v.format("YYYY-MM-DD")); setPage(1); } }} />



            <Button icon={<ReloadOutlined />} loading={running} onClick={() => { setPage(1); load(date, true); }}>Refresh</Button>



            <div className="fbr-toolbar-actions">



              <Button icon={<CopyOutlined />} disabled={!rows.length} onClick={onCopy}>Copy</Button>



              <Button icon={<FileExcelOutlined />} disabled={!rows.length} onClick={onExcel}>Excel</Button>



              <Button icon={<FilePdfOutlined />} disabled={!rows.length} onClick={onPDF}>PDF</Button>



            </div>



            {search.trim() && <Text className="fbr-count">Showing {rows.length} of {dataRows.length}</Text>}



          </div>



          <div className="fbr-table-wrap">



            <Table



              className="fbr-table"



              rowKey={(item) => item.code || "unit"}



              loading={running}



              columns={columns}



              dataSource={rows}



              size="small"



              tableLayout="fixed"



              scroll={{ x: "max-content" }}



              pagination={{ current: page, pageSize: 10, showSizeChanger: false, onChange: setPage,



                showTotal: (total, range) => `${range[0]}–${range[1]} of ${total} units` }}



              summary={() => rows.length ? (



                <Table.Summary.Row>



                  <Table.Summary.Cell index={0} colSpan={2}><strong>Total</strong></Table.Summary.Cell>



                  {EXPORT_FIELDS.slice(1).map(([, field], i) => (



                    <Table.Summary.Cell key={field} index={i + 2} align="center">



                      <strong>{fmt(displayedTotal[field])}</strong>



                    </Table.Summary.Cell>



                  ))}



                </Table.Summary.Row>



              ) : null}



            />



          </div>



        </div>



      </div>



    </div>



  );



}
